import {
    getNWayConfirmationMode,
    NWayConfirmationModal,
} from 'app/shared/modal/n_way_confirmation/n_way_confirmation_modal.service';
import { PromisedConfirmationModal } from 'app/shared/modal/confirmation/promised_confirmation_modal';

/**
 * @ngdoc service
 * @name ims.shared.service:ConfirmationModal
 * @description
 */
export const DEFAULT_CANCEL_TEXT = 'cancel';
export const DEFAULT_CONFIRM_TEXT = 'confirm';

export class ConfirmationModal extends NWayConfirmationModal {
    callbackRun;
    modal;

    constructor(
        message: string,
        confirmCallback: () => any,
        cancelCallback: () => any = undefined,
        escapeCallback: () => any = undefined,
        confirmText: string = 'Confirm',
        cancelText: string = 'Cancel',
        displayCancelButton: boolean = true,
        alternativeStyle: boolean = false,
    ) {
        const modes = [
            getNWayConfirmationMode(
                DEFAULT_CONFIRM_TEXT,
                PromisedConfirmationModal.CONFIRMED,
                confirmText,
                false,
                false,
                true,
                confirmCallback,
            ),
            getNWayConfirmationMode(
                DEFAULT_CANCEL_TEXT,
                PromisedConfirmationModal.CANCELLED,
                cancelText,
                true,
                true,
                displayCancelButton,
                cancelCallback,
            ),
        ];

        super(message, modes, alternativeStyle);
    }
}
